import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/messaging'
import { config } from '~/components/common/config'

export const firebaseApp = firebase.initializeApp(config.firebaseConfig())
export const firestore = firebaseApp.firestore()

const { Timestamp } = firebase.firestore
export { Timestamp }
